import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Switch from '../../../../../components/Switch';
import { ListFilters } from "../../../../../interfaces/property.interface";
import { AuthContext } from '../../../../../contexts/AuthContext';
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import { RoleCodes } from '../../../../../enums';

interface TableHeaderSectionProps {
  total: number;
  filters: ListFilters;
  onFilterChange: (filters: ListFilters) => void;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, filters, onFilterChange }) => {
  const { t } = useTranslation();
  const { loggedInUser } = useContext(AuthContext);

  const handleSwitchChange = (e: any, name: string) => {
    const newFilters = {
      ...filters,
      [name]: e.target.checked ? '1' : '0'
    };
    onFilterChange(newFilters);
  };

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-home-5-line ri-26px"></i>
            <h5 className="mx-3 my-0">{t("property.list.pageTexts.table.headerSection.properties")} ({total})</h5>
          </div>
          {(loggedInUser.role_code === RoleCodes.system_admin || loggedInUser.role_code === RoleCodes.admin) && (
            <div className="d-flex align-items-center">
              <Switch
                checked={filters.myProperties === '1'}
                onChange={handleSwitchChange}
                label={t("property.list.pageTexts.filters.myProperties")}
                name={VALIDATION_FIELD_MAPPING.myProperties}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TableHeaderSection;